<script setup lang="ts">
import { computed } from "vue";
import { useDisplay } from "vuetify";
import { useSnackStore } from "@/stores/snackStore";
import type { ISnackItem } from "@/stores/snackStore";
import { useSettings } from "@/composables/shared/useSettings";

const snackStore = useSnackStore();
const { smAndDown } = useDisplay();
const { isDarkMode } = useSettings();

const queueLocation = computed(() => (smAndDown.value ? "top" : "bottom"));

const messagesOf = (item: ISnackItem): string[] =>
  Array.isArray(item.message) ? item.message : [item.message];
</script>

<template>
  <div
    class="global-snackbar-host tw:z-toast"
    data-testid="global-snackbar"
  >
    <v-snackbar-queue
      v-model="snackStore.queue"
      :location="queueLocation"
      closable
      :total-visible="5"
    >
      <template #text="{ item }">
        <div class="tw:max-w-xs">
          <ol
            v-if="messagesOf(item as ISnackItem).length > 1"
            class="tw:list-decimal tw:pl-4 tw:space-y-1 tw:not-dark:!text-white"
          >
            <li
              v-for="(message, index) in messagesOf(item as ISnackItem)"
              :key="index"
            >
              {{ message }}
            </li>
          </ol>
          <div
            v-else
            class="tw:not-dark:!text-white"
          >
            {{ messagesOf(item as ISnackItem)[0] }}
          </div>
        </div>
      </template>
      <template #actions="{ props }">
        <v-btn
          :color="isDarkMode ? undefined : 'white'"
          :variant="isDarkMode ? 'text' : undefined"
          :size="isDarkMode ? 'small' : undefined"
          v-bind="props"
        >
          <v-icon
            icon="mdi-close"
            :size="isDarkMode ? 'small' : undefined"
          />
        </v-btn>
      </template>
    </v-snackbar-queue>
  </div>
</template>

<style>
@reference "@/tailwind-reference.css";

.v-overlay.v-snackbar {
  @apply tw:!z-toast;
}
</style>
